import notificationSlice from './notificationSlice';

export default notificationSlice;
